<script setup>
import { ref } from "vue";

const props = defineProps({
  options: Array
});

const options = ref(props.options ? [...props.options] : []);

if (options.value.length === 0) {
  options.value.push({ value: "", label: "" });
}

function addOption() {
  options.value.push({ value: "", label: "" });
}
</script>

<template>
  <div>
    <label for="optionInputs">{{ $t("Options") }}</label>
    <div v-for="option in options" class="form-inline mb-4" id="optionInputs">
      <input type="text" name="option_values[]" v-model="option.value" :placeholder="$t('Value')" class="form-control mr-3">
      <input type="text" name="option_labels[]" v-model="option.label" :placeholder="$t('Label')" class="form-control">
    </div>
  </div>

  <button type="button" class="btn btn-outline-primary mb-3" @click="addOption">
    {{ $t("Add Option") }}
  </button>
</template>
